import React, {Component} from 'react'

import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect
} from 'react-router-dom'

import {connect} from 'react-redux'

import NotFound from '../scenes/notFound'
import {CoDispositivo} from '../scenes/dispositivo'
import {CoAcesso} from '../scenes/acesso'
import {Login} from '../scenes/login'
import {Main} from '../scenes/main'
// import {Home} from '../scenes/home'

class Routes extends Component {
  render () {
    return (
      <Router>
        <Switch>
          <Route exact path="/" render={() => (<Redirect to="/login"/>)} />
          <Route exact path="/login" render={() => this.renderLogin()} />
          <Route path="/main" render={() => this.renderMain()} />
          <Route component={NotFound} />
        </Switch>
      </Router>
    )
  }

  renderLogin () {
    let {token} = this.props

    if (token) {
      return (<Redirect to="/main/accounts"/>)
    }
    return (<Login />)
  }

  renderMain () {
    let {token} = this.props

    if (!token) {
      return (<Redirect to="/login"/>)
    }

    return (
      <Main>
        <Route exact path="/main/:conta/devices" component={CoDispositivo} />
        <Route exact path="/main/accounts" component={CoAcesso} />
      </Main>
    )
  }
}

function mapStateToProps (state) {
  let {token} = state.auth

  return {
    token
  }
}

export default connect(mapStateToProps)(Routes)



// WEBPACK FOOTER //
// ./src/routes/index.js